import StarsComponent from '../stars';

const Reviews = (props: any) => {
  const dataFull = props?.data?.date?.split('T')[0];
  const date = new Date(dataFull);
  date.setDate(date.getDate() + 1);
  const day = date?.getDate();
  const year = date?.getFullYear();
  const month = date?.toLocaleString('default', { month: 'long' });

  return (
    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
      <div className="card sv-review-card sv-card-equal-height">
        <div className="card-body">
          <h5 className="customer-name">{props?.data?.name}</h5>
          <div className="date d-flex align-items-center">
            <StarsComponent data={props?.data?.rating}></StarsComponent>
            <div className="mt-1">
              {day} {month} {year}
            </div>
          </div>
          <p className="para">{props?.data?.text} </p>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
